import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n); // 全局挂载

const messages = {
  en: {
    meta: {
      home: {
        title: "wireChina 2026 - Home - The 12th China International Wire & Cable Industry Exhibition",
        keywords: "Shanghai cable exhibition...",
        description: "China International Wire & Cable Industry Exhibition..."
      },
      // 其他页面的翻译...
    }
  },
  zh: {
    meta: {
      home: {
        title: "首页-第12届中国国际线缆及线材展览会",
        keywords: "上海线缆展，国际线缆工业展览，电缆研究所，电线电缆展，电线电缆展会哪个不错，国际电线电缆展，上海线缆设备展，中国国际线缆及线材展览会，中国电器工业协会，拉丝机设备，绞线机，拉丝模具，塑料挤出机，橡胶挤出机，铜线，线盘，改性聚丙烯，铜包铝电缆，pvc电缆料造粒机，激光测径仪，中广核，万马，新宏泰，星基，德阳东方，华源，恒丰，易藤",
        description: "中国国际线缆及线材展览会（wire China）是上海电缆研究所有限公司主办的国际线缆工业展览会。第12届中国国际线缆及线材展览会将于2026年9月21日-24日在上海新国际博览中心举办。中国国际线缆工业展览会着力呈现线材制造及精加工机械、线缆专用制造设备、辅助加工设备、线缆（光缆）用原辅材料、特种电线电缆、测控技术及仪器设备及相关领域的产品。由中国电器工业协会电线电缆分会与上海电缆研究所有限公司共同举办的中国电线电缆行业大会系列活动将于同期举办。"
      },
      // 其他页面的翻译...
    }
  }
}

// 检测浏览器语言
function getBrowserLanguage() {
  const browserLang = navigator.language || navigator.userLanguage;
  if (browserLang && browserLang.startsWith('zh')) {
    return 'zh';
  } else {
    return 'en';
  }
}

// 从localStorage获取语言设置，保持与main.js一致
function getLocale() {
  const lang = localStorage.getItem("lang");
  if (lang === 'ZH') {
    return 'zh';
  } else if (lang === 'EN') {
    return 'en';
  } else {
    return getBrowserLanguage();
  }
}

export const i18n = new VueI18n({
    locale: getLocale(), // 从localStorage中获取，否则使用浏览器语言
    messages: {
        zh: require("./lan/zh"), // 中文语言包
        en: require("./lan/en") // 英文语言包
    }
});

export default i18n;
